import { Component, OnInit, Input } from '@angular/core';
import { HotelAddress } from '../../api/model/hotel/hotel-address.model';

@Component({
  selector: 'stay-mgmt-hotel-address',
  templateUrl: './hotel-address.component.html',
  styleUrls: ['./hotel-address.component.scss']
})
export class HotelAddressComponent implements OnInit {
  @Input() address: HotelAddress;

  constructor() { }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/hotel-address/hotel-address.component.ts